'use client';

import { Skeleton } from '@/components/ui/app-skeleton';
import { cn } from '@/lib/ui/utils';

import { getProposalFeedGridClass } from './proposal-feed-grid';

/** Desktop table row placeholder (lg+ only). */
export function ProposalFeedRowSkeleton(): React.ReactNode {
  return (
    <div
      className={cn(
        'hidden lg:grid',
        getProposalFeedGridClass(),
        'rounded-card bg-background-primary px-4 py-4 lg:py-3',
      )}
      aria-hidden="true"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="box-border size-12 shrink-0 rounded-control bg-background-tertiary p-1">
          <Skeleton className="block h-full w-full rounded-[calc(var(--radius-control)-0.25rem)]" />
        </div>
        <div className="flex flex-col gap-1.5 min-w-0 flex-1">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-1.5 w-full rounded-full" />
      </div>

      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>

      <div className="flex items-center gap-2">
        <div className="flex">
          <Skeleton className="size-6 rounded-full" />
          <Skeleton className="size-6 -ml-3 rounded-full" />
          <Skeleton className="size-6 -ml-3 rounded-full" />
        </div>
        <Skeleton className="h-4 w-8" />
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Skeleton className="size-4 rounded-full" />
          <Skeleton className="h-4 w-12" />
        </div>
        <Skeleton className="h-3 w-1/2" />
      </div>

      <div className="flex items-center gap-2 min-w-0">
        <Skeleton className="size-6 rounded-full" />
        <div className="flex flex-col gap-1 min-w-0 flex-1">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      </div>
    </div>
  );
}
